import { elementSectionFragmentSchema } from "./elementSectionFragment";
import { validateAndTriggerEvent } from "../listener";
import { Types } from "../types";
export var elementClickMeta = {
    "gtm": true,
    "deprecated": false,
    "name": "elementClick",
    "origName": "elementClick"
};
var elementClickContextNames = [];
export var elementClickEventSchema = Types.object.of({
    element: Types.object.of({
        type: elementSectionFragmentSchema.isRequired,
        itemType: Types.const("element").isRequired,
        itemId: Types.string.isRequired,
        itemName: Types.string.isRequired,
        source: Types.enum(["dom element id", "link url", "resource string key"]),
    }).isRequired,
    watchparty: Types.object.of({
        roomId: Types.string,
    }),
});
/**
 * Trigger elementClick event
 *
 * Scope - collect click interaction data for all those page/screen elements that are not related of any specific feature. Triggering condition - event is fired every time a users clicks on a page/screen element.
 *
 * @param {Object} payload
 * @param {Object} payload.element - string
 * @param {body|float|footer|header|navigation|sidebar|sticky} payload.element.type - string
 * @param {(element)} payload.element.itemType - string
 * @param {string} payload.element.itemId - string
 * @param {string} payload.element.itemName - string
 * @param {(dom element id|link url|resource string key)} [payload.element.source] - string
 * @param {Object} [payload.watchparty] - string
 * @param {string} [[payload.watchparty].roomId] - string
 * @returns {undefined}
 */
export function triggerElementClickEvent(payload) {
    return validateAndTriggerEvent(elementClickMeta, elementClickEventSchema, payload, elementClickContextNames);
}
//# sourceMappingURL=elementClickEvent.js.map